import {createStore, combineReducers} from 'redux';
import userInfoReducer from './reducers/user';
import billboardReducer from './reducers/billboard';
import bandReducer from './reducers/band';
import requestReducer from './reducers/request';

let reducer = combineReducers({
    user: userInfoReducer,
    billboard: billboardReducer,
    band: bandReducer,
    request: requestReducer
});

let store = createStore(
    reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    );
export default store;